import axios from "@/api/axios";

export const postCsvData = async (data: {
  emails: string[];
  importOption: string;
  subscriptionPromotionLogicId: string;
}) => {
  const res = await axios.post("/addUsersToSubscriptionPromotion", data);
  return res.data;
};

export const removeResidents = async (data: {
  emails: string[];
  subscriptionPromotionLogicId: string;
}) => {
  const res = await axios.post("/removeResident", data);
  return res.data;
};

// Utility function to split the emails array into smaller chunks.
export const chunkArray = (array: string[], chunkSize: number): string[][] => {
  return Array.from({ length: Math.ceil(array.length / chunkSize) }, (_, index) =>
    array.slice(index * chunkSize, index * chunkSize + chunkSize)
  );
};

export const validateEmail = (email: string): boolean => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};
